import "./Modale.scss";

const Modale = ({children}) => {
  return (
    <div className="modale p-3 p-md-5 bg-white rounded">{children}</div>
  )
};

export default Modale;